// @flow
import React, { Component } from "react";

import Spinner from "@atlaskit/spinner";
import DateRangeIcon from "@material-ui/icons/DateRange";
import InfiniteScroll from "react-infinite-scroller";
import dateFormat from "../utils/localdateformat";

import {
    SpinnerContainer,
    Messages,
    Entry,
    Title,
    Text,
    Name,
    Footer,
    Icon,
    DataCell,
    DataCellText,
    Content,
    Spacer
} from "./styled";
import { decode } from "../utils/string";

type Props = {|
    messages: ComponentType<any>,
    onFetchMessages: Function,
|};

type State = {
    isLoading: boolean,
    maxRowsToDisplay: Number,
    writingMessage: boolean
};

class MessagesPageView extends Component<Props, State> {
    // We set the loading state at the beginning after which the state can only be set to
    // loaded through the spinner. This allows us to have a 'completed' animated for the spinner.
    constructor(props) {
        super(props);
        const { messages } = props;
        this.state = {
            isLoading: messages === null,
            maxRowsToDisplay: 10
        };
    }

    componentDidMount() {
        if (this.state.isLoading) {
            this.props.onFetchMessages();
        }
    }
    render() {
        const { messages } = this.props;

        if (this.state.isLoading) {
            return (
                <SpinnerContainer>
                    <Spinner
                        size="medium"
                        isCompleting={this.props.messages != null}
                        onComplete={() => this.setState({ isLoading: false })}
                    />
                </SpinnerContainer>
            );
        }

        const displayedMessages = [];
        for (let i = 0; i < messages.length && i < this.state.maxRowsToDisplay; i += 1) {
            const message = messages[i];
            displayedMessages.push(<Spacer key={`spacer${message.id}`} />);
            displayedMessages.push(
                <Entry key={`message${message.id}`}>
                    <Content>
                        <Name>{decode(message.name)}</Name>
                        {message.title !== null &&
                            message.title !== "No Title" && <Title>{decode(message.title)}</Title>}
                        <Text>{decode(message.text)}</Text>
                    </Content>

                    <Footer>
                        <DataCell>
                            <Icon>
                                <DateRangeIcon />
                            </Icon>
                            <DataCellText>{dateFormat(message.date, "mmm dS yyyy")}</DataCellText>
                        </DataCell>
                    </Footer>
                </Entry>
            );
        }

        return (
            <div>
                <Messages>
                    <InfiniteScroll
                        pageStart={0}
                        loadMore={() =>
                            this.setState({
                                maxRowsToDisplay: this.state.maxRowsToDisplay + 5
                            })
                        }
                        hasMore={this.state.maxRowsToDisplay < messages.length}
                        loader={
                            <div className="loader" key={0}>
                                Loading ...
                            </div>
                        }
                    >
                        {displayedMessages}
                    </InfiniteScroll>
                </Messages>
                <Spacer key="spacer" />
            </div>
        );
    }
}

export default MessagesPageView;



// WEBPACK FOOTER //
// ./src/messages-page-view/view.js